import {Component, OnInit} from "@angular/core";
import {lastValueFrom} from "rxjs";
import {CatalogService} from "../../../Services/CatalogManagement/catalog.service";
import {ValidFeatureService} from "../../../Services/validFeature.service";

@Component({
  selector: "catalogExport",
  templateUrl: "catalogExport.component.html",
  styleUrl: './catalogExport.component.css',
  standalone: false
})
export class CatalogExportComponent implements OnInit {

  featureSystemsInCatalogForExport: any[] = [];
  selectedFeatureSystemIdsForExport: string;
  useAlternativeFeatureSystem: boolean = false;
  featureSystemsLoading: boolean = true;
  constructor(
    public catalogService: CatalogService,
    public validFeatureService: ValidFeatureService
  ) {
  }
  
  async ngOnInit() {

    var catalog = this.catalogService.catalog;
    
    let result = await lastValueFrom(this.validFeatureService.getCatalogSystems(this.catalogService.catalog.id, this.catalogService.catalog.customerId));
    result = result.filter(x => x.name != "udf_NMTECHNICALDETAILS-1.0");
    this.featureSystemsInCatalogForExport = result;
    this.featureSystemsLoading = false;

    this.selectedFeatureSystemIdsForExport = catalog.alternativeFeatureSystemIDUsedForExport;
  }

  async updateCatalogExportSettings() {
    var catalog = this.catalogService.catalog;
    catalog.alternativeFeatureSystemIDUsedForExport = this.selectedFeatureSystemIdsForExport;

    await this.catalogService.updateCatalog();
  }

  alternativeFeatureSystemIsUsed(): boolean {
    return !(!this.selectedFeatureSystemIdsForExport || this.selectedFeatureSystemIdsForExport.trim().length === 0);
  }

}
